import TableRow from '@mui/material/TableRow';
import IconTooltipButton from '../../../../button/IconTooltipButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CustomAvatar from '../../../../avatar/Avatar';
import { Tooltip, Typography } from '@mui/material';
import Requirements from './Requirements';
import { formatBytes } from '../../../../../utils/mimetype';

const img = {
  display: 'block',
  width: 60,
  height: 60
};

const PreviewList = ({ files, setFiles, isLoading, uploaded = [], maxFileSize }) => {

  return (
    <aside
      className={[
        'flex flex-col absolute bottom-0 inset-x-0 overflow-auto ',
        isLoading ? 'top-0' : 'top-44'
      ].join(' ')}
    >
      <div className='px-2 h-20 bg-background sticky top-0px text-xl flex justify-between text-primary z-1'>
        <Requirements maxFileSize={maxFileSize} />
        <Typography>
        {files.length} Photos
        </Typography>
      </div>
      {files.map((file, index) => {
        const fileUploaded = uploaded.find((item) => item.name === file.name);
        return (
          <TableRow component={'div'} key={file.name} className='px-4 py-1 flex gap-4 items-center justify-between'>
            <div className='flex items-center gap-1 text-center'>
              <span className='max-w-50px min-w-50px'>{index + 1}</span>
              <CustomAvatar
                srcComplete={file.preview}
                src={file.preview}
                variant='square'
                style={img}
                onLoad={() => {
                  URL.revokeObjectURL(file.preview);
                }}
              />
            </div>
            <div className='max-w-250px min-w-250px'>{file.name}</div>
            <div className='max-w-150px min-w-150px'>{formatBytes(file.size)}</div>
            <div className='max-w-50px min-w-50px text-right'>
              {isLoading ? (
                <>
                  {fileUploaded ? (
                    fileUploaded.error ? 
                    <Tooltip title={fileUploaded.error} placement='top' arrow>
                      <FontAwesomeIcon icon='exclamation-triangle' className='text-secondary cursor-pointer' />
                    </Tooltip>
                      : <FontAwesomeIcon icon='check' color='green' />
                  ) : (
                    <FontAwesomeIcon icon='spinner' spin />
                  )}
                </>
              ) : (
                <IconTooltipButton
                  id={`delete-${file.name}`}
                  title='Delete'
                  icon='trash-alt'
                  onClick={() => {
                    const newFiles = files.filter((f) => f.name !== file.name);
                    setFiles(newFiles);
                  }}
                />
              )}
            </div>
          </TableRow>
        )
      })}
    </aside>
  );
};

export default PreviewList;
